<template>
        <div class="lead-generator-wrapper">
            <h2 class="h2-header">Lead-Generator</h2>
            <v-text-field :loading="loading" density="compact" variant="outlined" rounded="lg" single-line hide-details v-model="webhookData" label="Webhook URL"></v-text-field>
            <div class="lead-generator-inside-wrapper">
                <v-text-field :loading="loading" class="number-text-field" density="compact" variant="outlined" rounded="lg" single-line type="number" hide-details v-model="amountLeads" label="Leads Anzahl"></v-text-field>
                <v-btn :loading="loading" class="gradient-color-primary" rounded="lg" @click="useGenerator()">Leads generieren</v-btn>
            </div>
        </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    data() {
        return {
            webhookData: '',
            amountLeads: 10
        }
    },
    computed: {
        ...mapState('leadGenerator', ['loading'])
    },
    methods: {
        ...mapActions('leadGenerator', ['generateLeads']),
        async useGenerator() {
            if (this.webhookData && this.amountLeads)
                await this.$store.dispatch('leadGenerator/generateLeads', { webhookData: this.webhookData, amountLeads: this.amountLeads })
        }
    }
}
</script>

<style lang="scss" scoped>
.lead-generator-wrapper {
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 12px;
    border: 1px solid rgb(196, 196, 196);
    border-radius: 12px;
    background-color: white;
}

.lead-generator-inside-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 16px;
}

.number-text-field {
    max-width: 100px;
}

</style>